import { ReactNode, createContext, useContext } from 'react';

type BigCalendarContext = {
  locale: 'en' | 'fr' | 'ar';
};

const BigCalendarContext = createContext<BigCalendarContext>({ locale: 'fr' });

export default function BigCalendarProvider({
  children,
  options = { locale: 'fr' },
}: {
  children: ReactNode;
  options?: BigCalendarContext;
}) {
  return (
    <BigCalendarContext.Provider value={options}>
      {children}
    </BigCalendarContext.Provider>
  );
}

export function useBigCalendarContext() {
  return useContext(BigCalendarContext);
}
